import UIDs from "../../../../UIDs";

const uid = UIDs.screens.course.recordsetting;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_RECORD_SETTING_ASYNC: `${uid}.saveRecordSettingAsync`,
    SAVE_RECORD_SETTING_SUCCESS: `${uid}.saveRecordSettingSuccess`,
    SAVE_RECORD_SETTING_FAILURE: `${uid}.saveRecordSettingFailure`,
};

export { ActionTypes };
